module.exports = __webpack_public_path__ + "media/images/banner_unite-eb4db6173c6f84414054d16b8783e162.png";